import clsx from 'clsx';

export default function QuickAddProducts({ title = 'Cela pourrait t\'intéresser', products = [], addToCartHandlerCallback }) {
  return (
    <div className="flex flex-col gap-4 w-full rounded-[12px] p-5 quick-add-product-border quick-add-product-background" style={{ boxShadow: 'rgba(130, 130, 130, 0.1) 0px 2px 8px 0px' }}>
      <p className='text-[15px] geomanistMedium'>Cela pourrait t'intéresser ?</p>
      <ul className='flex flex-col gap-6'>
        {products.map((product) => (
          <QuickAddProductItem key={product._id} product={product} onClickCallback={(event) => addToCartHandlerCallback(event, product)}/>
        ))}
      </ul>
    </div>
  );
}


const QuickAddProductItem = ({ product, onClickCallback }) => {
  return (
      <div className='flex items-center justify-between w-full'>
        <div className='flex items-center justify-center gap-5'>
          <div className='flex items-center rounded-[12px] p-1 h-[44px] w-[44px]'>
            <img src={product.image} alt={product.name} className="object-contain h-full w-full" />
          </div>

          <div className='flex flex-col gap-3'>
            <p className='text-[12px] geomanistBook'> {product.name}</p>
            <p className='text-[15px] geomanistMedium'>{product.price}€</p>
          </div>
        </div>
          <QuickAddProductButton text="Ajouter" onClickCallback={onClickCallback}/>
    </div>
  )
}


const QuickAddProductButton = ({ onClickCallback = () => {}, text = 'Ajouter' }) => {

  const className = 'purchase-button quick-add-product-button bottom-btn-shadow';
  return (
    <div>
      <button
        className={clsx(
          className,
          'shadow-[0_4px_0_#D9CA0C] text-[14px]'
        )}
        onClick={onClickCallback}
      >
        {text}
      </button>
    </div>
  )
}